import { combineReducers } from 'redux';
import { settingsReducer } from 'travco-services';
import { pendingTasksReducer } from 'react-redux-spinner';
import { reducer as oidcReducer } from 'redux-oidc';
import dataReducer from './data-reducer';
import hotelSearchReducer from './hotel-search-reducer';
import inventoryReducer from './inventory-reducer';
import globalDataReducer from './global-data-reducer';

const rootReducer = combineReducers({
    oidc: oidcReducer,
    settings: settingsReducer,
    pendingTasks: pendingTasksReducer,
    data: dataReducer,
    hotelSearch: hotelSearchReducer,
    model: inventoryReducer,
    globalData: globalDataReducer
});

export default rootReducer;
